<app-simple-coat-mix [job]="job()" coatId="primer"></app-simple-coat-mix>